/**
 * Legacy-Redirect: /commissions/:id → /splits/:id — Story 0.2
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/commissions/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/splits/$id', params, replace: true })
  },
  component: () => null,
})
